export default function errorHandler (e, a) {
  const error = new Error(e)
  error.message = e.response.data
  throw error
}



// WEBPACK FOOTER //
// ./src/api/error-handler.js